import { Helper } from '../Helper';
export class MapMapHelper extends Helper {
    constructor(options) {
        super();
        this.map = options.map;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitOp(node, 'NEWMAP');
        sb.emitHelper(node, options, sb.helpers.rawIteratorReduce({
            each: (innerOptions) => {
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'XTUCK');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'ROT');
                this.map(innerOptions);
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'SETITEM');
            },
        }));
    }
}

//# sourceMappingURL=MapMapHelper.js.map
